import { START_LOCATION } from 'vue-router';
import type { NavigationGuardWithThis } from 'vue-router';
import { resolveVaultRedirect } from '@/features/Product/composables/vaultRedirect';

export const vaultRedirectGuard: NavigationGuardWithThis<undefined> = (to, from, next) => {
  if (from !== START_LOCATION) return next();

  const redirect = resolveVaultRedirect(to);
  if (!redirect) return next();

  return next({ ...redirect, replace: true });
};
